<template>
    <div :id="tempId" style="position:absolute;left:-1000px;width:0;height:0;">
        <share-btn ref="shareBtn" :config="conf" :shareData="shareData"></share-btn>
    </div>
</template>
<script>
import ShareBtn from 'ShareBtn/index.vue';

export default {
    name: 'ShareWrapper',
    components: {
        ShareBtn,
    },
    props: {
        tempId: {
            type: String,
            default: 'shareId',
        },
        shareData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            conf: {
                shareText: '分享',
                shareTpis: '点击发送给朋友'
            }
        }
    },
    methods: {
        showShareTips(callback, timelineTitle, conf) {
            let config = Object.assign({}, conf);
            this.$refs.shareBtn.showShare(callback, timelineTitle, config.useJsapi || '');
        },
        setShare(shareData, callback, timelineTitle) {
            this.$refs.shareBtn.setShare(shareData, callback, timelineTitle);
        },
    },
};
</script>
